import React, { createContext, useEffect, useState } from "react"
import { onAuthStateChanged, processUserSession } from "../../services/auth.service"
import { getRoutesByRole } from "../../utils/routes.utils"
import { auth } from "../../config/firebase.config"
/**
 * @typedef {import('../../services/auth.service.d.ts').UserData} UserData
 */

/** @type {React.Context<{user: UserData, routes: any[], loading: boolean, refreshUser: () => Promise<void>}>} */
export const SessionContext = createContext({ user: undefined, routes: [], loading: false, refreshUser: async () => {} })

export function SessionProvider({ children }) {
  /** @type {ReturnType<typeof useState<UserData>>} */
  const [user, setUser] = useState()
  const [loading, setLoading] = useState(false)
  const [routes, setRoutes] = useState([])

  const refreshUser = async () => {
    setLoading(true)
    try {
      await processUserSession(auth.currentUser, setUser)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setLoading(true)
    const unsubscribe = onAuthStateChanged(setUser)

    return () => {
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (user) {
      setRoutes(getRoutesByRole(user?.projectRole))
    } else {
      setRoutes([])
    }
    setLoading(false)
  }, [user])

  return (
    <SessionContext.Provider value={{ user, routes, loading, refreshUser }}>
      {children}
    </SessionContext.Provider>
  )
}
